export function getRefreshToastMsgKey(subscriptionId: string): string {
  return `subscriptionsRefreshToastMessage:${subscriptionId}`;
}

export function refreshAndShowToast(toastMessage: string, subscriptionId: string): void {
  sessionStorage.setItem(getRefreshToastMsgKey(subscriptionId), toastMessage);
  location.reload();
}
